import React from "react";

const SettingDashboard = () => {
  return <div className="w-full flex justify-center items-center">setting dash</div>;
};

export default SettingDashboard;
